import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  /* Pretendard 자체 호스팅 (CDN dynamic-subset 대신 — 윈도우 등 모든 환경에서 확실히 로드) */
  @font-face {
    font-family: 'Pretendard Variable';
    font-weight: 45 920;
    font-style: normal;
    font-display: swap;
    src: url('/fonts/PretendardVariable.woff2') format('woff2-variations'),
         url('/fonts/PretendardVariable.woff2') format('woff2');
  }

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html, body, #root {
    width: 100%;
    min-height: 100%;
    font-family: 'Pretendard Variable', Pretendard, -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Malgun Gothic', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    background-color: #F5F7FA;
    color: #1A1A2E;
    touch-action: pan-x pan-y;
    -webkit-text-size-adjust: 100%;
    -ms-text-size-adjust: 100%;
    overscroll-behavior: none;
  }

  /* 모바일 키보드 대응: body가 줄어들지 않도록 */
  html {
    height: -webkit-fill-available;
  }
  body {
    min-height: 100vh;
    min-height: -webkit-fill-available;
  }

  #root {
    position: relative;
    background-color: #F5F7FA;
    min-height: 100vh;
  }

  /* 사용자 앱은 모바일 사이즈, 관리자·랜딩은 풀 너비 */
  #root:has([data-admin]),
  #root:has([data-fullwidth]) {
    max-width: none;
    background-color: #F7F8FA;
  }

  #root:not(:has([data-admin])):not(:has([data-fullwidth])) {
    max-width: 480px;
    margin: 0 auto;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.05);
  }

  a {
    text-decoration: none;
    color: inherit;
  }

  button {
    cursor: pointer;
    border: none;
    outline: none;
    background: none;
    font-family: inherit;
  }

  input, textarea, select {
    font-family: inherit;
    outline: none;
    /* 모바일 키보드 올라올 때 input이 뷰포트 안에 보이도록 */
    scroll-margin-bottom: 120px;
    /* iOS 줌 방지 (16px 이상이면 줌 안 함) */
    font-size: 16px !important;
  }

  ul, ol {
    list-style: none;
  }

  img {
    max-width: 100%;
  }

  ::-webkit-scrollbar {
    display: none;
  }
`;

export default GlobalStyle;
